import { Routes } from '@angular/router';
import { RoleGuard } from '@shared/guards/role.guard';

export const routesOperations: Routes = [
  {
    path: '1001',
    data: { breadcrumb: '1001' },
    loadComponent: () =>
      import(
        './add-people-control-list/add-people-control-list.component'
      ),
    canActivate: [RoleGuard],
  },
  {
    path: '1002',
    data: { breadcrumb: '1002' },
    children: [
      {
        path: '',
        data: { breadcrumb: 'Consulta', updatePerson: false },
        loadComponent: () =>
          import(
            './add-category-and-subcategory/add-category-and-subcategory.component'
          ),
      },
      {
        path: ':id',
        data: { breadcrumb: 'Detalle', updatePerson: false },
        loadComponent: () =>
          import(
            './add-category-and-subcategory-detail/add-category-and-subcategory-detail.component'
          ),
      },
    ],
    canActivate: [RoleGuard],
  },
  {
    path: '1003',
    data: { breadcrumb: '1003' },
    children: [
      {
        path: '',
        data: { breadcrumb: 'Consulta', updatePerson: true },
        loadComponent: () =>
          import(
            './add-category-and-subcategory/add-category-and-subcategory.component'
          ),
      },
      {
        path: ':id',
        data: { breadcrumb: 'Detalle', updatePerson: true },
        loadComponent: () =>
          import(
            './add-category-and-subcategory-detail/add-category-and-subcategory-detail.component'
          ),
      },
    ],
    canActivate: [RoleGuard],
  },
  {
    path: '1034',
    data: { breadcrumb: '1034' },
    children: [
      {
        path: 'search-people-unlocked',
        data: { breadcrumb: 'Consultar desbloqueados' },
        children: [
          {
            path: '',
            data: { breadcrumb: 'Listar' },
            loadComponent: () =>
              import(
                '../listas/pages/list-people-temporarily-unlocked/list-people-temporarily-unlocked.component'
              ),
          },
          {
            path: 'temporary-detail/:idPeople',
            data: { breadcrumb: 'Detalle' },
            loadComponent: () =>
              import(
                '../listas/pages/people-temporarily-unlocked-detail/people-temporarily-unlocked-detail.component'
              ),
          },
          {
            path: ':idPeople',
            data: { breadcrumb: 'Detalle' },
            loadComponent: () =>
              import(
                '../listas/pages/logs-people-unlocked-detail/logs-people-unlocked-detail.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: 'search-people-listas',
        data: { breadcrumb: 'Desbloquear personas' },
        children: [
          {
            path: '',
            data: { breadcrumb: 'Listar' },
            loadComponent: () =>
              import(
                '../listas/pages/people-list/people-list.component'
              ),
          },
          {
            path: ':idPeople',
            data: { breadcrumb: 'Detalle' },
            loadComponent: () =>
              import(
                '../listas/pages/people-unlocked/people-unlocked.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '**',
        redirectTo: 'search-people-unlocked',
      },
    ],
  },
];
